import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button, Modal, Popconfirm } from 'ui/base';

import ReportIssueContentForm from './ReportIssueContentForm';

/**
 * @typedef {Object} ReportIssueFormProps
 * @property {() => void} onCancel
 * @property {boolean} confirmLoading
 * @property {() => void} handleSubmit
 */

/**
 * @type {React.FC<ReportIssueFormProps>}
 */
export const ReportIssueForm = ({ onCancel, confirmLoading, handleSubmit, hasValidationErrors }) => (
  <Modal
    open
    large
    confirmLoading={confirmLoading}
    title={<FormattedMessage id="about.reportIssue" defaultMessage="Submit a request" />}
    footer={
      <div className="d-flex justify-content-between">
        <Popconfirm
          onConfirm={onCancel}
          placement="bottomLeft"
          title={<FormattedMessage id="reportIssue.confirmExist.message" defaultMessage="All entered information will be lost." />}
          okText={<FormattedMessage id="yes" defaultMessage="Yes" />}
          cancelText={<FormattedMessage id="cancel" defaultMessage="Cancel" />}
        >
          <Button>
            <FormattedMessage id="cancel" defaultMessage="Cancel" disabled={confirmLoading} />
          </Button>
        </Popconfirm>

        <Button onClick={handleSubmit} type="primary" disabled={hasValidationErrors} loading={confirmLoading}>
          <FormattedMessage id="submit" defaultMessage="Submit" />
        </Button>
      </div>
    }
  >
    <div>
      <ReportIssueContentForm disabled={confirmLoading} />
    </div>
  </Modal>
);
